import { useEffect } from "react";

import { onActiveBusinessFiltersChangeState } from "@keepeek/commons";
import { useSetRecoilState } from "recoil";

import { useActiveFiltersFromURL } from "./useActiveFiltersFromURL";

export const useInitOnActiveBusinessFiltersChange = () => {
  const { setActiveFilters } = useActiveFiltersFromURL();
  const setOnActiveBusinessFiltersChange = useSetRecoilState(onActiveBusinessFiltersChangeState);
  useEffect(() => {
    // Set the atom that contains a function to update activeFilters
    setOnActiveBusinessFiltersChange(() => setActiveFilters);
  }, [setActiveFilters, setOnActiveBusinessFiltersChange]);
};
